import type { IMoleculeCallout } from '@belong/types';
import { FSystemIcon } from '../elements/elementSystemIcon.factory';
import { FRichText } from '../richText.factory';

export const FMoleculeCallout = (data: any): IMoleculeCallout => {
  const { colour, isSolid, icon, title, description } = data.fields;
  return {
    id: data.sys.id,
    contentType: data.sys.contentType.sys.id,
    colour,
    isSolid,
    icon: icon && FSystemIcon(icon),
    title: title && FRichText(title),
    description: description && FRichText(description)
  };
};
